import { useRegion } from 'common/hooks/region';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { getMissingCredentials } from 'services/clients/credentials';
import { QueryKeys } from '../../queries';

export const MissingCredentials: React.FC = () => {
  const region = useRegion();
  const countsQuery = useQuery([QueryKeys.MissingCredentialsCount, region.code], ({ signal }) =>
    getMissingCredentials(region.code, signal)
  );

  if (countsQuery.data && countsQuery.data.missing > 0) {
    return (
      <div className="bg-red-50 rounded-md px-3 py-2 border-red-900 border inline-block text-red-900">
        <div className="flex items-center space-x-2">
          <ReportProblemIcon className="text-[1.2rem]" />
          <h4 className="font-bold uppercase">
            {countsQuery.data.missing} / {countsQuery.data.total} Credentials missing
          </h4>
        </div>
      </div>
    );
  }

  return null;
};
MissingCredentials.displayName = 'MissingCredentials';
